import React, { useRef, useState, useEffect, useCallback } from 'react'
import { useDirtyFlag } from '../hooks/useDirtyState.js'   // straz_v4 (29. 9. 2026): rozpísaný formulár drží spoločnú stráž odchodu (ústava 53.1.b)
import EmailReplyBox from '../components/EmailReplyBox.jsx'
import { todayLocal, hladaj } from '../theme.js'

// Spis — vlákno zákazky. Časová os všetkej komunikácie + udalostí (podľa mockupu zakazka_spis).
// Kanály: E-mail · KD · WhatsApp · Hovor/SMS · Problém · Platby · Reklamácie. Lievik píše sám.
const C = { card: '#fff', surf: '#f4f3ee', surf2: '#faf9f5', line: 'rgba(0,0,0,.12)', t1: '#1f1f1d', t2: '#5F5E5A', t3: '#8a897f', info: '#185FA5', infoBg: '#E6F1FB', ok: '#0F6E56', okBg: '#E1F5EE', warn: '#854F0B', warnBg: '#FAEEDA', dang: '#A32D2D', dangBg: '#FCEBEB', brand: '#D85A30', wa: '#1FA855', purp: '#185FA5' }
// event_type → kanál (ikona, farba, label, do ktorého filtra patrí)
const CH = {
  email_in:   { ic: '', l: 'E-mail', col: C.info, filt: 'mail' },
  email_out:  { ic: '', l: 'E-mail', col: C.info, filt: 'mail' },
  kd:         { ic: '', l: 'KD', col: C.brand, filt: 'kd' },
  porada:     { ic: '', l: 'Porada', col: C.brand, filt: 'kd' },
  problem:    { ic: '', l: 'Problém', col: C.dang, filt: 'prob' },
  riesenie:   { ic: '', l: 'Riešenie', col: C.ok, filt: 'prob' },
  platba:     { ic: '', l: 'Platba', col: C.warn, filt: 'pay' },
  reklamacia: { ic: '', l: 'Reklamácia', col: C.dang, filt: 'rek' },
  whatsapp:   { ic: '', l: 'WhatsApp', col: C.wa, filt: 'wa' },
  sms:        { ic: '', l: 'SMS', col: C.info, filt: 'tel' },
  hovor:      { ic: '', l: 'Hovor', col: C.info, filt: 'tel' },
  dokument:   { ic: '', l: 'Dokument', col: C.purp, filt: 'doc' },
  poznamka:   { ic: '', l: 'Poznámka', col: C.t2, filt: 'note' },
}
const ch = (t) => CH[t] || CH.poznamka
// plná sada filtrov (mockup) — vidíš odkiaľ čo prišlo
const FILTERS = [['all', 'Všetko'], ['kd', 'KD'], ['mail', 'E-mail'], ['wa', 'WhatsApp'], ['tel', 'Hovor/SMS'], ['prob', 'Problém'], ['pay', 'Platby'], ['rek', 'Reklamácie']]
const ADD_TYPES = ['poznamka', 'hovor', 'sms', 'kd', 'porada', 'problem', 'platba', 'dokument']
const fmtD = (s) => { if (!s) return ''; const d = String(s).slice(0, 10).split('-'); return d.length === 3 ? `${d[2]}-${d[1]}-${d[0]}` : s }
const tok = () => localStorage.getItem('kamir_token') || ''
const api = (u, o = {}) => fetch(u, { ...o, headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + tok(), ...(o.headers || {}) } })

export default function SpisTab({ projectId }) {
  const [events, setEvents] = useState([])
  const [q, setQ] = useState('')
  const [filt, setFilt] = useState('all')
  const [loading, setLoading] = useState(true)
  const [modal, setModal] = useState(null)

  const load = useCallback(async () => {
    setLoading(true)
    try { const r = await api('/api/spis/' + encodeURIComponent(projectId)); const d = await r.json(); setEvents((d && d.events) || []) }
    catch (_) {} finally { setLoading(false) }
  }, [projectId])
  useEffect(() => { load() }, [load])

  // p44 (Mirko 17. 9. 2026: „potrebujem, aby do zákazky bola možnosť pridať do spisu aj manuálne, napr. zápis z KD“):
  // súbory sa najprv nahrajú do dokumentov zákazky a potom sa k zápisu priložia
  const save = async (ev, subory) => {
    try {
      const prilohy = []
      for (const file of (subory || [])) {
        const fd = new FormData()
        fd.append('file', file); fd.append('title', (ev.titul || 'Zápis') + ' — ' + file.name)
        const ru = await fetch('/api/docmgmt/project/' + encodeURIComponent(projectId) + '/upload', { method: 'POST', headers: { Authorization: 'Bearer ' + tok() }, body: fd })
        const du = await ru.json().catch(() => ({}))
        if (!ru.ok) throw new Error(du.error || 'Príloha sa nenahrala')
        prilohy.push({ name: du.path || du.name || file.name, title: file.name })
      }
      const r = await api('/api/spis/' + projectId, { method: 'POST', body: JSON.stringify({ ...ev, prilohy }) })
      if (!r.ok) throw new Error()
      setModal(null); load()
    } catch (e) { alert('Uloženie zlyhalo' + (e && e.message ? ': ' + e.message : '')) }
  }
  const del = async (id) => { if (!window.confirm('Archivovať zápis?')) return; try { await api('/api/spis/' + projectId + '/' + id, { method: 'DELETE' }); load() } catch (_) {} }

  const qq = q.trim().toLowerCase()
  const shown = events.filter(e => {
    if (filt !== 'all' && ch(e.event_type).filt !== filt) return false
    if (qq && !hladaj(((e.titul || '') + ' ' + (e.text || '') + ' ' + (e.kto || '') + ' ' + ch(e.event_type).l), qq)) return false
    return true
  })
  const cnt = (f) => f === 'all' ? events.length : events.filter(e => ch(e.event_type).filt === f).length

  return (
    <div style={{ padding: '4px 2px', background: C.surf2 }}>
      {/* Trinity */}
      <div style={{ display: 'flex', gap: 9, alignItems: 'flex-start', background: 'linear-gradient(90deg,#f4f3ee,#faf9f5)', border: '0.5px solid rgba(0,0,0,.12)', borderRadius: 12, padding: '11px 14px', marginBottom: 14, fontSize: 12.5, color: '#5F5E5A' }}>
        <span style={{ fontSize: 16, lineHeight: 1 }}></span>
        <div><b>Trinity:</b> Vlákno zbieram automaticky z e-mailov (lievik) — prijaté aj odoslané. Zápisy z KD/porád, problémy a platby pribúdajú sem. <span style={{ color: C.t3 }}>WhatsApp a SMS pripojíme cez bránu.</span></div>
    </div>

      {/* Toolbar */}
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12, flexWrap: 'wrap' }}>
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="Hľadať v komunikácii… (meno, predmet, text)" style={{ flex: '1 1 300px', minWidth: 200, padding: '9px 12px', border: '0.5px solid ' + C.line, borderRadius: 9, fontFamily: 'inherit', fontSize: 13, outline: 'none', background: C.card }} />
        <button onClick={() => setModal({ event_type: 'poznamka', datum: todayLocal() })} style={{ padding: '9px 16px', border: 'none', background: C.brand, color: '#fff', borderRadius: 9, cursor: 'pointer', fontWeight: 600, fontSize: 13, fontFamily: 'inherit' }}>+ Pridať zápis</button>
    </div>

      {/* Odpovedať e-mailom (rovnaký komponent ako v Reklamáciách/Dopytoch) */}
      <div style={{ marginBottom: 12 }}>
        <EmailReplyBox target={{ project_id: projectId }} defaultSubject="" onSent={load} />
      </div>

      {/* Filtre — plná sada */}
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 16 }}>
        {FILTERS.map(([f, l]) => {
          const on = filt === f, n = cnt(f)
          return <span key={f} onClick={() => setFilt(f)} style={{ fontSize: 12, padding: '5px 11px', borderRadius: 999, border: '0.5px solid ' + (on ? C.brand : C.line), background: on ? C.brand : C.card, color: on ? '#fff' : C.t2, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 5 }}>{l}{n ? <span style={{ background: on ? 'rgba(255,255,255,.25)' : C.surf, borderRadius: 999, fontSize: 10, padding: '0 6px' }}>{n}</span> : null}</span>
        })}
    </div>

      {loading ? <div style={{ color: C.t3, padding: 20 }}>Načítavam…</div> : (
        !shown.length ? <div style={{ color: C.t3, padding: '28px 8px', textAlign: 'center' }}>{q || filt !== 'all' ? 'Nič nezodpovedá filtru.' : 'Vlákno je zatiaľ prázdne — pribudne z e-mailov, alebo pridaj zápis ručne.'}</div> : (
          <div style={{ position: 'relative', paddingLeft: 30 }}>
            <div style={{ position: 'absolute', left: 11, top: 4, bottom: 4, width: 2, background: C.line }} />
            {shown.map(e => {
              const m = ch(e.event_type)
              return (
                <div key={e.id} style={{ position: 'relative', marginBottom: 16 }}>
                  <div style={{ position: 'absolute', left: -30, top: 0, width: 24, height: 24, borderRadius: '50%', background: m.col, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, border: '3px solid ' + C.surf2 }}>{m.ic}</div>
                  <div style={{ background: C.card, border: '0.5px solid ' + C.line, borderLeft: '3px solid ' + m.col, borderRadius: 8, padding: '9px 12px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', fontSize: 11, color: C.t3, marginBottom: 3 }}>
                      <span style={{ fontSize: 10, padding: '1px 7px', borderRadius: 999, fontWeight: 500, background: m.col + '1a', color: m.col }}>{m.l}</span>
                      <span>{fmtD(e.datum)}</span>
                      {e.kto && <span style={{ color: C.t1, fontWeight: 500 }}>· {e.kto}</span>}
                      {e.zdroj && e.zdroj !== 'rucne' && <span style={{ color: C.purp }}>· {e.zdroj}</span>}
                      <span onClick={() => del(e.id)} title="archivovať" style={{ marginLeft: 'auto', cursor: 'pointer', color: '#cbd5e1', fontSize: 13 }}>✕</span>
                  </div>
                    {e.titul && <div style={{ fontSize: 13.5, fontWeight: 500, lineHeight: 1.35, color: C.t1 }}>{e.titul}</div>}
                    {e.text && <div style={{ fontSize: 12.5, color: C.t2, lineHeight: 1.5, marginTop: 2, whiteSpace: 'pre-wrap' }}>{e.text}</div>}
                    {Array.isArray(e.prilohy) && e.prilohy.length > 0 && <div style={{ marginTop: 6, display: 'flex', gap: 6, flexWrap: 'wrap' }}>{e.prilohy.map((p, i) => { const nm = typeof p === 'string' ? p : (p.name || 'príloha'); return <a key={i} href={'/uploads/' + nm} target="_blank" rel="noreferrer" style={{ fontSize: 11, color: C.info, background: C.infoBg, borderRadius: 6, padding: '2px 8px', display: 'inline-flex', gap: 4, alignItems: 'center', textDecoration: 'none' }}>{nm}</a> })}</div>}
                </div>
              </div>
              )
            })}
        </div>
        )
      )}

      {modal && <AddModal init={modal} onClose={() => setModal(null)} onSave={save} />}
  </div>
  )
}

function AddModal({ init, onClose, onSave }) {
  const [f, setF] = useState({ event_type: init.event_type || 'poznamka', datum: init.datum || '', kto: '', titul: '', text: '' })
  const _s0 = useRef(null); if (_s0.current === null) _s0.current = JSON.stringify(f); useDirtyFlag(JSON.stringify(f) !== _s0.current, { key: 'spis-zaznam', discard: () => { onClose && onClose() } })   // straz_v4
  const [subory, setSubory] = useState([])   // p44: prílohy zápisu (napr. zápisnica z KD)
  const [uklada, setUklada] = useState(false)
  const set = (k, v) => setF(s => ({ ...s, [k]: v }))
  const fld = { width: '100%', padding: '9px 11px', border: '0.5px solid ' + C.line, borderRadius: 8, fontFamily: 'inherit', fontSize: 13, boxSizing: 'border-box', outline: 'none' }
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 14, padding: 22, width: 'min(560px,92vw)', maxHeight: '90vh', overflowY: 'auto' }}>
        <h3 style={{ margin: '0 0 14px', fontSize: 17 }}>Nový zápis do vlákna</h3>
        <div style={{ display: 'grid', gap: 11 }}>
          <div style={{ display: 'flex', gap: 10 }}>
            <label style={{ flex: 1, fontSize: 12, color: C.t2 }}>Typ
              <select value={f.event_type} onChange={e => set('event_type', e.target.value)} style={{ ...fld, marginTop: 4 }}>
                {ADD_TYPES.map(k => <option key={k} value={k}>{ch(k).ic + ' ' + ch(k).l}</option>)}
            </select>
          </label>
            <label style={{ flex: 1, fontSize: 12, color: C.t2 }}>Dátum
              <input type="date" value={f.datum} onChange={e => set('datum', e.target.value)} style={{ ...fld, marginTop: 4 }} />
          </label>
        </div>
          <label style={{ fontSize: 12, color: C.t2 }}>Od koho / účastník
            <input value={f.kto} onChange={e => set('kto', e.target.value)} placeholder="napr. Samuel Horváth (Chemkostav)" style={{ ...fld, marginTop: 4 }} />
        </label>
          <label style={{ fontSize: 12, color: C.t2 }}>Titul
            <input value={f.titul} onChange={e => set('titul', e.target.value)} placeholder="napr. Kontrolný deň 13.5. — zápisnica" style={{ ...fld, marginTop: 4 }} />
        </label>
          <label style={{ fontSize: 12, color: C.t2 }}>Text
            <textarea value={f.text} onChange={e => set('text', e.target.value)} rows={5} placeholder="Čo sa dohodlo / kto komu čo napísal…" style={{ ...fld, marginTop: 4, resize: 'vertical' }} />
        </label>
          <label style={{ fontSize: 12, color: C.t2 }}>Priložiť dokument (napr. zápisnica z KD, foto, PDF)
            <input type="file" multiple onChange={e => setSubory(Array.from(e.target.files || []))} style={{ ...fld, marginTop: 4, padding: '7px 9px' }} />
            <span style={{ display: 'block', marginTop: 4, color: C.t3 }}>
              {subory.length ? subory.map(s => s.name).join(', ') : 'Nepovinné. Súbor sa uloží aj medzi dokumenty zákazky.'}
            </span>
        </label>
      </div>
        <div style={{ display: 'flex', gap: 9, justifyContent: 'flex-end', marginTop: 18 }}>
          <button onClick={onClose} style={{ padding: '9px 16px', border: '0.5px solid ' + C.line, background: '#fff', borderRadius: 9, cursor: 'pointer', fontFamily: 'inherit', fontWeight: 600 }}>Zrušiť</button>
          <button disabled={uklada} onClick={async () => { setUklada(true); try { await onSave(f, subory) } finally { setUklada(false) } }} style={{ padding: '9px 18px', border: 'none', background: C.brand, color: '#fff', borderRadius: 9, cursor: uklada ? 'default' : 'pointer', fontFamily: 'inherit', fontWeight: 600, opacity: uklada ? 0.6 : 1 }}>{uklada ? 'Ukladám…' : 'Uložiť'}</button>
      </div>
    </div>
  </div>
  )
}
